import './MudLab.scss'
import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { fetchPageMeta } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { MudLab } from '#src/pages/mud-lab/MudLab.js'
import { getMudLabData } from '#src/pages/mud-lab/mudLabData.js'
import { mergeMeta } from '#src/seo.js'
import type { Route } from './+types/mud-lab.route.js'

export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, meta] = await Promise.all([
    getMudLabData(lang),
    fetchPageMeta('mudLabPage', lang, '/mud-lab'),
  ])
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function MudLabLayout({ loaderData }: Route.ComponentProps): ReactNode {
  return (
    <MudLab data={loaderData.data}>
      <Outlet />
    </MudLab>
  )
}
